// Bilingual translations (English / Spanish) for Yoshitaka Karate-Do

export const translations = {
  en: {
    lang: { en: "English", es: "Spanish" },
    nav: {
      home: "Home",
      about: "About",
      gallery: "Gallery",
      contact: "Contact",
    },
    form: {
      name: "Name",
      email: "Email",
      phone: "Phone",
      submit: "Submit",
      sending: "Sending...",
      invalid: "Please provide your name and email.",
      success: "Thank you! Your message has been sent.",
      error: "Sorry, something went wrong. Please try again later.",
      hero_title: "Begin your Journey!",
      register_title: "Register",
    },
    welcome: {
      title: "Welcome!",
      subtitle: "Come Join our class!",
      cta: "Contact Us",
    },
    about_home: {
      title: "About Us",
      cta: "More info",
      body:
        "Yoshitaka is a network of Karate schools (dojos) serving the Chicagoland area. We are proud to teach the traditional art of Karate in a supportive and encouraging environment where every student can thrive. Our classes focus on building confidence, discipline, fitness, and self-defense skills while keeping the spirit of Karate alive.",
    },
    ourclass: {
      eyebrow: "Our Class",
      heading: "Come live the real experience",
    },
    gallery_home: {
      eyebrow: "Our Dojo",
      title: "Gallery",
      view_full: "View Full Gallery",
    },
    gallery_page: {
      title: "Gallery",
      subtitle: "Moments from our dojo, classes and community.",
      hint: "Click any photo to view it full-size. Use the arrow keys to navigate.",
      view: "View",
    },
    instructors: {
      eyebrow: "Meet our team",
      title: "Instructors",
      location_label: "Location details:",
      phone_label: "Phone:",
    },
    reviews: {
      title: "Here is what our customers say",
      count: "23 reviews",
      google: "Google Review",
    },
    about_page: {
      title: "About Us",
      subtitle: "Tradition. Discipline. Community.",
      our_story: "Our Story",
      cta: "Get in touch",
      body: [
        "Yoshitaka is a network of Karate schools (dojos) serving the Chicagoland area. We are proud to teach the traditional art of Karate in a supportive and encouraging environment where every student can thrive. Our classes focus on building confidence, discipline, fitness, and self-defense skills while keeping the spirit of Karate alive.",
        "We welcome students of all ages and skill levels, from children taking their first class to adults continuing their martial arts journey. At Yoshitaka, families and individuals alike will find a positive community that values respect, growth, and the joy of learning Karate together.",
      ],
      teach_title: "What we teach",
      values: [
        {
          title: "Discipline",
          text: "Build focus, respect and consistency through traditional Karate practice.",
        },
        {
          title: "Confidence",
          text: "Develop self-esteem and mental strength as you progress through ranks.",
        },
        {
          title: "Self-Defense",
          text: "Learn practical, time-tested techniques to protect yourself and others.",
        },
      ],
    },
    contact: {
      title: "Join Us Today",
      subtitle:
        "Connect with us to learn more about our karate classes and how you can become a part of our community.",
      info_title: "Contact Information",
      phone_label: "Phone",
      email_label: "Email",
      locations: "Locations",
    },
    footer: {
      description:
        "A network of Karate schools (Dojos) located in the Chicagoland area. Traditional Karate classes for all ages.",
      locations: "Locations",
      get_in_touch: "Get in Touch",
      rights: "All rights reserved.",
      tagline: "Traditional Karate · Chicagoland Area",
    },
    memorial: {
      eyebrow: "In Loving Memory Of",
      support_message:
        "Please join us in supporting the family during this difficult time. Every contribution, big or small, helps them find comfort and strength.",
      donate_cta: "Donate on GoFundMe",
      powered_by: "Secure donations powered by GoFundMe",
      quote:
        "\u201cThe LORD bless thee, and keep thee; the LORD make his face shine upon thee, and be gracious unto thee; the LORD lift up his countenance upon thee, and give thee peace.\u201d",
      quote_ref: "Numbers 6:24-26",
      service_label: "Service",
      service_time: "Sunday, August 30, 2026 · 6:00 PM",
      service_address: "2400 S Harvey Ave, Berwyn, IL 60402",
      burial_label: "Burial · Meeting at Linhart",
      burial_time: "Monday, August 31, 2026 · 10:00 AM",
      burial_address: "6820 West Cermak Road, Berwyn, IL 60402",
      cemetery_label: "Cemetery · Section Y",
      cemetery_address_label: "Address",
      cemetery_address: "6900 S Cass Ave, Darien, IL 60561",
      show_more: "Cemetery details",
      show_less: "Show less",
      enlarge: "Click to enlarge",
    },
    gallery_captions: {
      dojo1: "Celebration in Class",
      dojo2: "Belt Ceremony",
      dojo3: "Class Demonstration",
      dojo4: "Yoshitaka Family Celebration",
      dojo5: "Certificate Day",
      kids1: "Kids Karate Celebration",
      kids2: "Little Warriors Group",
      karate1: "Yoshitaka Emblem",
      sensei: "Sensei Training",
      nguyen: "Discipline & Focus",
      sam: "Class in Session",
      g1: "Kata Practice",
      g2: "Kata at Sunset",
      g3: "Traditional Karate",
      g6: "Sparring Practice",
    },
  },

  es: {
    lang: { en: "Ingl\u00e9s", es: "Espa\u00f1ol" },
    nav: {
      home: "Inicio",
      about: "Nosotros",
      gallery: "Galer\u00eda",
      contact: "Contacto",
    },
    form: {
      name: "Nombre",
      email: "Correo",
      phone: "Tel\u00e9fono",
      submit: "Enviar",
      sending: "Enviando...",
      invalid: "Por favor ingresa tu nombre y correo.",
      success: "\u00a1Gracias! Tu mensaje ha sido enviado.",
      error: "Lo sentimos, algo sali\u00f3 mal. Intenta de nuevo m\u00e1s tarde.",
      hero_title: "\u00a1Comienza tu Viaje!",
      register_title: "Reg\u00edstrate",
    },
    welcome: {
      title: "\u00a1Bienvenido!",
      subtitle: "\u00a1Ven y \u00fanete a nuestra clase!",
      cta: "Cont\u00e1ctanos",
    },
    about_home: {
      title: "Sobre Nosotros",
      cta: "M\u00e1s informaci\u00f3n",
      body:
        "Yoshitaka es una red de escuelas de Karate (dojos) que atiende el \u00e1rea de Chicago. Nos enorgullece ense\u00f1ar el arte tradicional del Karate en un ambiente de apoyo donde cada estudiante puede desarrollarse. Nuestras clases se enfocan en construir confianza, disciplina, condici\u00f3n f\u00edsica y habilidades de defensa personal, manteniendo vivo el esp\u00edritu del Karate.",
    },
    ourclass: {
      eyebrow: "Nuestra Clase",
      heading: "Ven a vivir la experiencia real",
    },
    gallery_home: {
      eyebrow: "Nuestro Dojo",
      title: "Galer\u00eda",
      view_full: "Ver Galer\u00eda Completa",
    },
    gallery_page: {
      title: "Galer\u00eda",
      subtitle: "Momentos de nuestro dojo, clases y comunidad.",
      hint:
        "Haz clic en cualquier foto para verla en pantalla completa. Usa las flechas del teclado para navegar.",
      view: "Ver",
    },
    instructors: {
      eyebrow: "Conoce a nuestro equipo",
      title: "Instructores",
      location_label: "Detalles de ubicaci\u00f3n:",
      phone_label: "Tel\u00e9fono:",
    },
    reviews: {
      title: "Esto es lo que dicen nuestros clientes",
      count: "23 rese\u00f1as",
      google: "Rese\u00f1a de Google",
    },
    about_page: {
      title: "Sobre Nosotros",
      subtitle: "Tradici\u00f3n. Disciplina. Comunidad.",
      our_story: "Nuestra Historia",
      cta: "Ponte en contacto",
      body: [
        "Yoshitaka es una red de escuelas de Karate (dojos) que atiende el \u00e1rea de Chicago. Nos enorgullece ense\u00f1ar el arte tradicional del Karate en un ambiente de apoyo donde cada estudiante puede desarrollarse. Nuestras clases se enfocan en construir confianza, disciplina, condici\u00f3n f\u00edsica y habilidades de defensa personal, manteniendo vivo el esp\u00edritu del Karate.",
        "Damos la bienvenida a estudiantes de todas las edades y niveles, desde ni\u00f1os que toman su primera clase hasta adultos que contin\u00faan su camino en las artes marciales. En Yoshitaka, familias e individuos encontrar\u00e1n una comunidad positiva que valora el respeto, el crecimiento y la alegr\u00eda de aprender Karate juntos.",
      ],
      teach_title: "Lo que ense\u00f1amos",
      values: [
        {
          title: "Disciplina",
          text: "Desarrolla enfoque, respeto y constancia mediante la pr\u00e1ctica tradicional del Karate.",
        },
        {
          title: "Confianza",
          text: "Desarrolla autoestima y fuerza mental a medida que avanzas de rango.",
        },
        {
          title: "Defensa Personal",
          text: "Aprende t\u00e9cnicas pr\u00e1cticas y probadas para protegerte a ti y a otros.",
        },
      ],
    },
    contact: {
      title: "\u00danete a Nosotros Hoy",
      subtitle:
        "Con\u00e9ctate con nosotros para conocer m\u00e1s sobre nuestras clases de karate y c\u00f3mo puedes ser parte de nuestra comunidad.",
      info_title: "Informaci\u00f3n de Contacto",
      phone_label: "Tel\u00e9fono",
      email_label: "Correo",
      locations: "Ubicaciones",
    },
    footer: {
      description:
        "Una red de escuelas de Karate (Dojos) ubicadas en el \u00e1rea de Chicago. Clases tradicionales de Karate para todas las edades.",
      locations: "Ubicaciones",
      get_in_touch: "Cont\u00e1ctanos",
      rights: "Todos los derechos reservados.",
      tagline: "Karate Tradicional \u00b7 \u00c1rea de Chicago",
    },
    memorial: {
      eyebrow: "En Amorosa Memoria",
      support_message:
        "Acomp\u00e1\u00f1anos apoyando a la familia en este momento dif\u00edcil. Cada contribuci\u00f3n, grande o peque\u00f1a, les ayuda a encontrar consuelo y fortaleza.",
      donate_cta: "Donar en GoFundMe",
      powered_by: "Donaciones seguras a trav\u00e9s de GoFundMe",
      quote:
        "\u201cEl Se\u00f1or te bendiga y te guarde; el Se\u00f1or haga resplandecer su rostro sobre ti, y tenga de ti misericordia; el Se\u00f1or alce sobre ti su rostro, y te d\u00e9 paz.\u201d",
      quote_ref: "N\u00fameros 6:24-26",
      service_label: "Servicio",
      service_time: "Domingo, 30 de agosto de 2026 \u00b7 6:00 PM",
      service_address: "2400 S Harvey Ave, Berwyn, IL 60402",
      burial_label: "Entierro \u00b7 Reuni\u00f3n en Linhart",
      burial_time: "Lunes, 31 de agosto de 2026 \u00b7 10:00 AM",
      burial_address: "6820 West Cermak Road, Berwyn, IL 60402",
      cemetery_label: "Cementerio \u00b7 Secci\u00f3n Y",
      cemetery_address_label: "Direcci\u00f3n",
      cemetery_address: "6900 S Cass Ave, Darien, IL 60561",
      show_more: "Detalles del cementerio",
      show_less: "Ver menos",
      enlarge: "Clic para ampliar",
    },
    gallery_captions: {
      dojo1: "Celebraci\u00f3n en Clase",
      dojo2: "Ceremonia de Cintas",
      dojo3: "Demostraci\u00f3n de Clase",
      dojo4: "Celebraci\u00f3n Familia Yoshitaka",
      dojo5: "D\u00eda del Certificado",
      kids1: "Celebraci\u00f3n de Karate Infantil",
      kids2: "Grupo de Peque\u00f1os Guerreros",
      karate1: "Emblema Yoshitaka",
      sensei: "Entrenamiento del Sensei",
      nguyen: "Disciplina y Enfoque",
      sam: "Clase en Sesi\u00f3n",
      g1: "Pr\u00e1ctica de Kata",
      g2: "Kata al Atardecer",
      g3: "Karate Tradicional",
      g6: "Pr\u00e1ctica de Combate",
    },
  },
};

// Path-based lookup helper (e.g., t("nav.home"))
export function tPath(bag, path) {
  const parts = path.split(".");
  let cur = bag;
  for (const p of parts) {
    if (cur == null) return path;
    cur = cur[p];
  }
  return cur == null ? path : cur;
}
